import { faExclamationTriangle, faInfoCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Tooltip from "components/Tooltip"
import React from "react"
import { AreaFragment_content_validateItems, EditModelAdvertAreaContentValidateKinds } from "schema"
import styled from "styled-components"
import cx from "classnames"
import { faStopCircle } from "@fortawesome/free-regular-svg-icons"

const ValidateErrorText: React.FC<{
  validationItems?: AreaFragment_content_validateItems[]
  validateErrorTexts?: string[] | undefined
}> = (props) => {
  const errorTexts = props.validateErrorTexts
    ? props.validateErrorTexts?.filter((error) => error !== null)
    : []

  return (
    <ValidateAreaErrorStyles>
      <div className={cx("content", {
        ["feView__content"]: true 
      })}>
        {props.validationItems && props.validationItems.length > 0 && (
          <Tooltip
            id={"baseRowTooltip"}
            delayShow={500}
            text={props.validationItems.map((error) => {
              return error.validationText + "\n"
            })}
          >
            {props.validationItems.some(q=>q.kind == EditModelAdvertAreaContentValidateKinds.ERROR) &&
              (            <div className={"validationErrorContainer"}>
                <FontAwesomeIcon
                  className={"errorIcon"}
                  icon={faExclamationTriangle}
                  size={"1x"}
                />
              </div>
              )
            }
            {!props.validationItems.some(q=>q.kind == EditModelAdvertAreaContentValidateKinds.ERROR) &&
              (            <div className={"validationErrorContainer"}>
                <FontAwesomeIcon
                  className={"errorIcon"}
                  icon={faInfoCircle}
                  size={"1x"}
                />
              </div>
              )
            }
          </Tooltip>
        )}

        {props.validateErrorTexts && props.validateErrorTexts.length > 0 && (
          <Tooltip
            id={"baseRowTooltip"}
            className={"baseRowTooltip"}
            delayShow={500}
            text={errorTexts.map((error) => {
              return `- ${error}\n`
            })}
          >
            <div
              className={"validationErrorContainer"}
            >
              <FontAwesomeIcon
                className={"errorIcon"}
                icon={faExclamationTriangle}
                size={"1x"}
              />
            </div>
          </Tooltip>
        )}
      </div>
    </ValidateAreaErrorStyles>
  )
}

const ValidateAreaErrorStyles = styled.div`
  .content {
    .baseRowTooltip {
      color: ${(props) => props.theme["--error-red"]};
    }
    .validationErrorContainer {
      margin-right: 10px;
      .errorIcon {
        color: ${(props) => props.theme["--error-red"]};
      }
    }
    &.feView__content {
      .baseRowTooltip {
        color: ${(props) => props.theme["--fe_primary"]};
      }
      .validationErrorContainer {
        .errorIcon {
          color: ${(props) => props.theme["--fe_primary"]};
        }
      }
    }
  }
`

export default ValidateErrorText
